export const ISSUED = 0
export const RETURNED = 1